import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';
import AIChatbot from './components/AIChatbot';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Services from './pages/Services';
import Contact from './pages/Contact';
import WhatsAppTest from './pages/WhatsAppTest';
import InternalTesting from './pages/InternalTesting';
import './App.css';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App min-h-screen flex flex-col">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/services" element={<Services />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/whatsapp-test" element={<WhatsAppTest />} />
              <Route path="/internal-testing" element={<InternalTesting />} />
            </Routes>
          </main>
          <Footer />
          <WhatsAppFloat />
          <AIChatbot />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
